import { render, staticRenderFns } from "./SeleccionarAsientosRegionNormal.vue?vue&type=template&id=270fd117&scoped=true"
import script from "./SeleccionarAsientosRegionNormal.vue?vue&type=script&lang=js"
export * from "./SeleccionarAsientosRegionNormal.vue?vue&type=script&lang=js"
import style0 from "./SeleccionarAsientosRegionNormal.vue?vue&type=style&index=0&id=270fd117&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270fd117",
  null
  
)

export default component.exports